module.exports = __webpack_public_path__ + "rgfw1.png?d400dd96c1180aaf4c7dec4619b5b611";


//////////////////
// WEBPACK FOOTER
// ./static/assets/rgfw1.png
// module id = 252
// module chunks = 0